define('Validation',['jquery', 'Toastr', 'ValidateJS', 'JSTemplate'], function($, Toastr, ValidateJS, template) {
	'use strict';

    return function(options) {
    	var defaults = {
    		autoToast: true,
            template: 'tplFormErrors',
            type: 'form'
    	},
    	allConstraints = {},
    	o,

        /**
         * [updateConstraints adds the constraints on top of existing ones]
         *
         * @param  Object newConstraints [new constraints as per requirements]
         *
         */
    	updateConstraints = function(newConstraints) {
            allConstraints = $.extend(allConstraints, newConstraints);
    	},

        /**
         * [isValid function returns true if form is valid else returns an object]
         *
         * @return Boolean or object
         */
    	isValid = function() {
            if(o.type === 'form') {
                return _formValidation();   
            } else if(o.type === 'field') {
                return _fieldValidation();
            } else if(o.type === 'json') {
                return _jsonValidation();
            }
            
    	},

        /**
         * [_formatErrorMsg returns string with error msgs]
         *
         * @param  Object errors [contains key value pairs of form fields]
         *
         * @return String [Error Msg HTML List]
         */
        _formatErrorMsg = function(errors) {
            return template(o.template,{errors: errors, props: o});
        },

        /**
         * [_formValidation validates if form fields are valid depending on constraints passed]
         *
         * @return true if form valid else object [Object contains errors Object, errorString and status]
         */
    	_formValidation = function() {
            var errors,
                msg,
                formValues = ValidateJS.collectFormValues(o.form, {trim: true});

            errors = ValidateJS(formValues, allConstraints);
            

            if(!errors) {
                return true;
            } else {

                if(o.autoToast) {
                    var toastr;

                    for(var key in errors) {
                        msg = errors[key][0];
                        //o.form[0][key].focus();
                        break;
                    }

                    toastr = new Toastr({
                        'message': msg,
                        'icon': 'ion-alert',
                        'class': 'toastr-error'
                    });
                }

                return {
                    status: false,
                    errorString: _formatErrorMsg(errors),
                    errors: errors
                };
            }            
    	},

        /**
         * [_fieldValidation validates single field against constraints passed]
         *
         */
        _fieldValidation = function() {
            var errors, msg;

            errors = ValidateJS.single(o.value, allConstraints);

            if(!errors) {
                return true;
            } else {

                if(o.autoToast) {
                    var toastr;

                    msg = errors[0];

                    toastr = new Toastr({
                        'message': msg,
                        'icon': 'ion-alert',
                        'class': 'toastr-error'
                    });    
                }
                

                return {
                    status: false,
                    errorString: _formatErrorMsg(errors),
                    errors: errors
                };
            }            


        },

        /**
         * [_jsonValidation validates single field against constraints passed]
         *
         */
        _jsonValidation = function() {
            var errors, msg;

            errors = ValidateJS(o.value, allConstraints);

            if(!errors) {
                return true;
            } else {

                if(o.autoToast) {
                    var toastr;

                    for (var key in errors) {
                        if (!errors.hasOwnProperty(key)) {
                            continue;
                        }

                        msg = errors[key][0];

                        break;
                    }

                    toastr = new Toastr({
                        'message': msg,
                        'icon': 'ion-alert',
                        'class': 'toastr-error'
                    });    
                }
                

                return {
                    status: false,
                    errorString: _formatErrorMsg(errors),
                    errors: errors
                };
            }            


        },

        /**
         * [init function is called in the beginning to initialize the module with custom values]
         *
         * @param  Object options [options with which the module needs to be initialized]
         *
         */
    	init = function(options) {
    		o = $.extend(defaults, options);

    		if((o.type === 'form' && !o.form) || !o.allConstraints || (o.type === 'field' && o.value === undefined) || (o.type === 'json' && o.value === undefined)) {
    			throw ('Custom Validation: Pass arguments correctly');
    		}

            if(o.type === 'form') {
                o.form = $(o.form);    
            }

    		allConstraints = $.extend(allConstraints, o.allConstraints);
    	};

        init(options);

    	return {
    		init: init,
    		updateConstraints: updateConstraints,
    		isValid: isValid
    	};
    };
});
